import { environment } from '../../../environments/environment';

export const PAYPHONE_CONFIG = {
  prepareUrl: environment.payphone.prepareUrl,
  confirmUrl: environment.payphone.confirmUrl,
  cancelUrl: environment.payphone.cancelUrl,
} as const;
